import React, {FC, useState} from "react";
import {useAxios} from "../../utils/hooks";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import {Breadcrumb, Button, Divider, message, Popconfirm, Tooltip} from "antd";
import {
    DeleteTwoTone,
    PlusOutlined,
    UploadOutlined,
    BorderlessTableOutlined,
    GlobalOutlined
} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import ButtonWithIcon from "../../components/buttons/button-with-icon";
import OrderModel from "../../models/orders/order-model";
import QuickDDSAssignment from "../../components/QuickDDSAssignment";
import QuickLocationAssignment from "../../components/QuickLocationAssignment";
import Drawer from "../../components/drawer/drawer";
import OrderDrawer from "../../forms/order-form";
import {useKeycloak} from '@react-keycloak/web';
import isAuthorized from "../../utils/is-authorized";

const OrdersScreen: FC = () => {

    const {keycloak} = useKeycloak();
    const [trigger, setTrigger] = useSafeState(false);
    const [ddsDrawerVisible, setDdsDrawerVisible] = useState(false);
    const [locationDrawerVisible, setLocationDrawerVisible] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<any>(null);

    const orderText = <Trans>Order</Trans>;

    const orderDrawer = Drawer(
        {
            title: orderText,
            children: <OrderDrawer/>,
            customClose: () => setTrigger(function(prev) { return !prev; })
        }
    );

    const canCreateOrders = isAuthorized(keycloak, ["EUDR_ADMIN", "EUDR_MSC_ADMIN", "EUDR_MSC_USER"]);

    const handleDelete = (record: any) => {
    };

    const handleAssignDDS = (record: any) => {
        setSelectedOrder(record);
        setDdsDrawerVisible(true);
    };

    const handleAssignLocation = (record: any) => {
        setSelectedOrder(record);
        setLocationDrawerVisible(true);
    };

    const action = (record: any) => {

        return (
            <>
                <Tooltip title={<Trans>Assign DDS</Trans>}>
                    <Button
                        size="small"
                        icon={<BorderlessTableOutlined />}
                        onClick={() => handleAssignDDS(record)}
                        style={{ marginRight: 8 }}
                    >
                        <Trans>Assign DDS</Trans>
                    </Button>
                </Tooltip>
                <Tooltip title={<Trans>Assign Location</Trans>}>
                    <Button
                        size="small"
                        icon={<GlobalOutlined />}
                        onClick={() => handleAssignLocation(record)}
                    >
                        <Trans>Assign Location</Trans>
                    </Button>
                </Tooltip>
            </>
        )
    };

    const actions = {
        width: 350,
        render: (text: string, record: any) => action(record),
        title: <Trans>Actions</Trans>,
        fixed: 'right',
        align: 'center'
    };

    const header = canCreateOrders ? (
        <>
            <Button type={'primary'} onClick={() => orderDrawer.open('Add new')} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Add new</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
            <Button onClick={() => alert('Upload File')} style={{ float: 'left' }}>
                <ButtonWithIcon
                    icon={<UploadOutlined />}
                    text={<Trans>.csv upload</Trans>}
                />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />
        </>
    ) : undefined;


    return (<>

            <>

                <Breadcrumb style={{marginBottom: 10}}>
                    <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'Orders'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    tableHeader={header}
                    model={OrderModel}
                    trigger={trigger}
                    allowRefreshButton={true}
                    allowExport={true}
                    pageSize={100}
                    scroll={{x: 1300, y: "65vh"}}
                    action={actions}
                />

                <QuickDDSAssignment
                    visible={ddsDrawerVisible}
                    order={selectedOrder}
                    onClose={() => setDdsDrawerVisible(false)}
                    onSuccess={() => { setTrigger(function(prev) { return !prev; }); }}
                />
                <QuickLocationAssignment 
                    visible={locationDrawerVisible}
                    order={selectedOrder}
                    onClose={() => setLocationDrawerVisible(false)}
                    onSuccess={() => { setTrigger(function(prev) { return !prev; }); }}
                />
            </>
            {canCreateOrders && orderDrawer.component}
        </>
    )
}
export default OrdersScreen;
